var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" 北京佰达康科技有限公司版权所有 | 京ICP备2021032350号-1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }